import * as React from "react";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./src/theme/theme";
import "./src/styles/global.scss";

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>{element}</ThemeProvider>
);
